var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortapapeles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 422.14 422.14",
    style: {
      enableBackground: "new 0 0 422.14 422.14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E1F4"
    },
    d: "M370.939,91.43v299.363c0,17.312-14.035,31.347-31.347,31.347H82.547 c-17.312,0-31.347-14.035-31.347-31.347V91.43c0-17.312,14.034-31.347,31.347-31.347h51.2v36.571H287.87V60.083h51.722 C356.905,60.083,370.939,74.117,370.939,91.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00CEB4"
    },
    d: "M287.87,60.083v36.571H133.747V31.348h38.139c3.926-18.232,20.012-31.274,38.661-31.347 c18.721-0.129,34.917,13.004,38.661,31.347h38.661V60.083z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083863"
    },
    d: "M122.776,281.601c-2.782,0.089-5.46-1.059-7.314-3.135l-21.42-21.943 c-4.047-4.24-4.047-10.911,0-15.151c4.204-3.841,10.709-3.609,14.629,0.522l14.106,14.629l33.437-31.869 c4.204-3.841,10.709-3.609,14.629,0.522c4.04,3.706,4.31,9.986,0.603,14.025c-0.192,0.21-0.394,0.411-0.603,0.603l-40.751,38.661 C128.161,280.435,125.532,281.562,122.776,281.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083863"
    },
    d: "M320.784,268.54H200.621c-5.771,0-10.449-4.678-10.449-10.449s4.678-10.449,10.449-10.449h120.163 c5.771,0,10.449,4.678,10.449,10.449S326.555,268.54,320.784,268.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083863"
    },
    d: "M320.784,184.948H200.621c-5.771,0-10.449-4.678-10.449-10.449 c0-5.771,4.678-10.449,10.449-10.449h120.163c5.771,0,10.449,4.678,10.449,10.449 C331.233,180.27,326.555,184.948,320.784,184.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083863"
    },
    d: "M122.776,365.193c-2.782,0.089-5.46-1.059-7.314-3.135l-21.42-21.943 c-4.047-4.24-4.047-10.911,0-15.151c4.204-3.841,10.709-3.609,14.629,0.522l14.106,14.629l33.437-31.869 c4.204-3.841,10.709-3.609,14.629,0.522c4.04,3.706,4.31,9.986,0.603,14.025c-0.192,0.21-0.394,0.411-0.603,0.603l-40.751,38.661 C128.161,364.027,125.532,365.154,122.776,365.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083863"
    },
    d: "M320.784,352.132H200.621c-5.771,0-10.449-4.678-10.449-10.449s4.678-10.449,10.449-10.449 h120.163c5.771,0,10.449,4.678,10.449,10.449S326.555,352.132,320.784,352.132z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 99.266,
    y: 145.242,
    style: {
      fill: "#00ACEA"
    },
    width: 62.171,
    height: 56.79
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortapapeles);
export default __webpack_public_path__ + "static/media/portapapeles.f929a4737f8958b1b3cdeee8dd5be224.svg";
export { ForwardRef as ReactComponent };